import React from "react";
import ReactDOM from "react-dom";
import { defineCustomElements } from "@ionic/pwa-elements/loader";
import { setupConfig, isPlatform } from "@ionic/react";
import { SplashScreen } from "@capacitor/splash-screen";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

/* Core CSS required for Ionic components to work properly */
import "@ionic/react/css/core.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";

/* Optional CSS utils that can be commented out */
import "@ionic/react/css/padding.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/display.css";

/* Theme variables */
import "./theme/variables.scss";

import { Provider } from "react-redux";
import { store } from "./store/store";
import { Capacitor } from "@capacitor/core";
import { SystemUi } from "./capacitor-plugins/system-ui";

setupConfig({
    mode: "ios",
    animated: !isPlatform("desktop"),
    hardwareBackButton: false,
});

//TODO: Ha kijön az ionic 5.0.8 vagy újabb akkor ezt ki lehet venni.
window.addEventListener(
    "keyboardDidShow",
    (e) => {
        window.dispatchEvent(new Event("resize")); //temporary scroll-assist fix
    },
    false
);

// Android 15+ (SDK >= 35) esetén CSS változók beállítása a natív mért értékekkel
if (Capacitor.getPlatform() === "android") {
    SystemUi.getNavigationInfo()
        .then((info: any) => {
            if (info && typeof info.navBarHeightPx === "number" && info.sdkInt >= 35) {
                document.documentElement.classList.add("android-15plus");
                document.documentElement.style.setProperty("--android-nav-bottom", `${info.navBarHeightPx}px`);
                if (typeof info.cameraCutoutTopPx === "number") {
                    document.documentElement.style.setProperty("--android-camera-top", `${info.cameraCutoutTopPx}px`);
                }
            }
        })
        .catch(() => {});
}

ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById("root")
);
SplashScreen.hide().catch(() => {});

defineCustomElements(window);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
